<template>
  <div/>
</template>

<script>
import ShareDialog from './ShareDialog'
import NativeWrapper from '../js/nativeWrapper.js'

export default {
  mounted () {
    this.$store.subscribe(
      async function (mutation, state) {
        switch (mutation.type) {
          case 'share':
            this.$store.commit('showLoading')
            this.shareLink(mutation.payload)
            break
        }
      }.bind(this)
    )
  },
  methods: {
    async shareLink (shareOpts) {
      this.$store.commit('hideLoading')

      // Workaround for iOS webView that doesn't support navigator.share
      if (NativeWrapper.iOS) {
        NativeWrapper.iOS.shareContent(shareOpts)
        return
      }

      // Workaround for Android webView that also :) doesn't support navigator.share
      if (NativeWrapper.android) {
        NativeWrapper.android.shareContent(shareOpts)
        return
      }

      // Safari on Mac: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1.2 Safari/605.1.15"
      // Safari on iPhone: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/604.3.5 (KHTML, like Gecko) Version/11.0.1 Safari/604.3.5 keel-pwa-ios"
      // Chrome on Android: "Mozilla/5.0 (Linux; Android 9; SM-G950F) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/76.0.3809.132 Mobile Safari/537.36"
      // Chrome on Mac: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/76.0.3809.132 Safari/537.36"
      if (navigator.share) {
        await navigator.share(shareOpts)
      } else {
        console.info('navigator.share not supported!')
        this.showShareModal(shareOpts)
      }
    },
    showShareModal (shareOpts) {
      this.$modal.show(
        ShareDialog,
        {
          title: shareOpts.title,
          text: shareOpts.text,
          url: shareOpts.url,
          poster: shareOpts.poster
        },
        {
          height: 'auto',
          width: '70%',
          adaptive: true
        }
      )
    }
  }
}
</script>
